/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
  }

  get({ q }) {
    return axios.get(this.url, {
      params: {
        q,
      },
    });
  }

  contacts({ q, page = 1, since, until }) {
    return axios.get(`${this.url}/contacts`, {
      params: {
        q,
        page: page,
        since,
        until,
      },
    });
  }

  conversations({ q, page = 1, since, until }) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        q,
        page: page,
        since,
        until,
      },
    });
  }

  messages({ q, page = 1, since, until, from, inboxId }) {
    return axios.get(`${this.url}/messages`, {
      params: {
        q,
        page: page,
        since,
        until,
        from,
        inbox_id: inboxId,
      },
    });
  }

  articles({ q, page = 1, since, until }) {
    return axios.get(`${this.url}/articles`, {
      params: {
        q,
        page: page,
        since,
        until,
      },
    });
  }

  pipelineCards({ q, page = 1 }) {
    return axios.get(`${this.url}/pipeline_cards`, {
      params: { q, page },
    });
  }

  followUps({ q, page = 1 }) {
    return axios.get(`${this.url}/follow_ups`, {
      params: { q, page },
    });
  }

  legalProcesses({ q, page = 1 }) {
    return axios.get(`${this.url}/legal_processes`, {
      params: { q, page },
    });
  }
}

export default new SearchAPI();
